<template>
  <div>
    <el-dialog :visible.sync="visible" width="880px" class="custom-el-wrapper" :close-on-click-modal="false">
      <template slot="title"><div class="el-dialog__title">{{ isGlobalShop ? '微信系统预设属性' : '微信搬家配置' }}<span v-if="shop.shop_name" class="shop-name">（{{ shop.shop_name }}）</span></div></template>
      <el-tabs v-model="activeTab">
        <el-tab-pane v-for="tab in configTabs" :key="tab.key" :name="tab.key" :label="tab.label" />
      </el-tabs>
      <div v-loading="loading" class="config-body">
        <section class="config-card attribute-card">
          <div class="card-header">
            <h3 class="card-title">{{ isGlobalShop ? '系统预设属性' : '类目属性设置' }}</h3>
            <div class="attribute-stats"><span class="stat-badge">已设置 {{ activeConfiguredCount }} 个属性</span><span class="stat-badge">{{ isGlobalShop ? '有效叶子类目' : '可经营' }} {{ categoryCount }} 个类目</span></div>
          </div>
          <div class="attribute-actions">
            <el-button type="primary" class="setting-button" :disabled="(!isGlobalShop && !activeTemplateId) || categoryCount === 0" @click="$refs.attributeDialog.show()">{{ isGlobalShop ? '配置系统预设属性' : '类目属性设置' }}</el-button>
            <el-button v-if="!isGlobalShop" class="setting-button sync-category-button" :loading="refreshing" @click="refreshCategories">刷新可经营类目</el-button>
            <el-button v-if="!isGlobalShop" class="setting-button secondary-button" :disabled="!activeConfiguredCount" :loading="clearing" @click="clearConfigs">清空配置</el-button>
            <el-button v-if="!isGlobalShop" class="setting-button secondary-button" :disabled="!activeTemplateId" :loading="globalImporting" @click="importGlobalAttributes">同步系统预设属性</el-button>
          </div>
          <p class="sync-tip"><i class="el-icon-info" /> {{ isGlobalShop ? '这里配置的是微信系统预设属性，普通店铺需手动确认后同步到自己的模板。' : '微信店铺的可经营类目变更后，可点击“刷新可经营类目”更新。' }}</p>
        </section>
      </div>
      <div v-if="!isGlobalShop" class="config-footer">
        <div class="footer-template-tip" role="note"><i class="el-icon-info" aria-hidden="true" /><span>铺货时将使用设置为【默认】模板中的配置</span></div>
        <span class="footer-template-label">搬家配置模板</span>
        <el-popover v-model="templatePopoverVisible" placement="top-start" width="340" trigger="click" popper-class="move-template-popover">
          <div class="template-popover-content">
            <el-input v-model.trim="templateKeyword" class="template-search" placeholder="请输入模板名称" prefix-icon="el-icon-search" clearable />
            <div class="template-option-list">
              <div v-for="item in filteredTemplates" :key="item.id" class="template-option" :class="{ active: Number(item.id) === Number(activeTemplateId) }" @click="selectTemplate(item)"><span>{{ item.name }}</span><i v-if="Number(item.id) === Number(activeTemplateId)" class="el-icon-check" /></div>
              <div v-if="!filteredTemplates.length" class="template-empty">暂无匹配模板</div>
            </div>
            <div class="template-popover-actions"><el-button type="text" @click="createTemplateFromPopover">新建模板</el-button><el-button type="text" @click="openManage">管理模板</el-button></div>
          </div>
          <div slot="reference" class="template-select-trigger"><span :class="{ placeholder: !activeTemplateId }">{{ activeTemplate.name || '请选择模板' }}</span><i class="el-icon-arrow-down" :class="{ open: templatePopoverVisible }" /></div>
        </el-popover>
        <el-button type="primary" class="sync-multi-button" :disabled="!activeTemplateId || syncSaving" @click="openSync">同步保存到多店</el-button>
      </div>
    </el-dialog>
    <WechatCategoryAttributeDialog ref="attributeDialog" :shop-id="shopId" :template-id="activeTemplateId" :global-mode="isGlobalShop" @saved="loadConfig" />
    <el-dialog v-if="!isGlobalShop" title="管理微信搬家配置模板" :visible.sync="manageVisible" width="760px" :close-on-click-modal="false" class="custom-el-wrapper">
      <el-alert class="template-manage-tip" type="info" title="铺货时将使用默认模板中的配置，请将需要用于铺货的模板设为默认。" show-icon :closable="false" />
      <el-table :data="manageRows" border max-height="420" empty-text="暂无模板"><el-table-column label="模板名称" min-width="380"><template slot-scope="scope"><div class="template-name-cell"><el-input v-model.trim="scope.row.name" maxlength="50" show-word-limit /><span v-if="scope.row.is_default" class="default-template-mark">默认</span></div></template></el-table-column><el-table-column label="操作" width="280"><template slot-scope="scope"><el-button type="text" :disabled="scope.row.is_default" @click="setDefault(scope.row)">设为默认</el-button><el-button type="text" @click="createTemplate(true, scope.row)">复制模板</el-button><el-button type="text" :disabled="scope.row.is_default || manageRows.length <= 1" @click="deleteTemplate(scope.row)">删除</el-button></template></el-table-column></el-table>
      <span slot="footer"><el-button :disabled="managing" @click="manageVisible = false">关闭</el-button><el-button type="primary" :loading="managing" @click="saveNames">确定</el-button></span>
    </el-dialog>
    <el-dialog v-if="!isGlobalShop" title="同步微信搬家配置到多店" :visible.sync="syncVisible" width="640px" :close-on-click-modal="false" class="custom-el-wrapper">
      <div class="sync-dialog-tip">请选择目标店铺及搬家配置模板。同步后，目标模板的整套搬家配置将被当前模板覆盖。</div>
      <el-table v-loading="syncLoading" :data="syncTargets" border max-height="420" empty-text="暂无其他正常授权的微信店铺"><el-table-column width="70" label="选择" align="center"><template slot-scope="scope"><el-checkbox v-model="scope.row.selected" /></template></el-table-column><el-table-column prop="shop_name" label="店铺" min-width="190" /><el-table-column label="搬家配置模板" min-width="260"><template slot-scope="scope"><el-select v-model="scope.row.target_template_id" :disabled="!scope.row.selected" placeholder="请选择模板" class="sync-template-select"><el-option v-for="template in scope.row.templates" :key="template.id" :label="template.name" :value="template.id" /></el-select></template></el-table-column></el-table>
      <span slot="footer"><el-button :disabled="syncSaving" @click="syncVisible = false">取消</el-button><el-button type="primary" :loading="syncSaving" @click="sync">保存</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import WechatCategoryAttributeDialog from './WechatCategoryAttributeDialog.vue'

export default {
  name: 'WxMoveConfig', components: { WechatCategoryAttributeDialog },
  data () { return { visible: false, loading: false, refreshing: false, clearing: false, activeTab: 'attribute', configTabs: [{ key: 'attribute', label: '属性设置' }], shopId: 0, shop: {}, templates: [], activeTemplateId: 0, categoryCount: 0, templatePopoverVisible: false, templateKeyword: '', manageVisible: false, managing: false, manageRows: [], syncVisible: false, syncLoading: false, syncSaving: false, syncTargets: [], isGlobalShop: false, globalConfiguredAttributeCount: 0, globalImporting: false } },
  computed: {
    activeTemplate () { return this.templates.find(item => Number(item.id) === Number(this.activeTemplateId)) || {} },
    filteredTemplates () { const keyword = String(this.templateKeyword || '').trim().toLowerCase(); return keyword ? this.templates.filter(item => String(item.name || '').toLowerCase().includes(keyword)) : this.templates },
    activeConfiguredCount () { return this.isGlobalShop ? this.globalConfiguredAttributeCount : Number(this.activeTemplate.configured_count || 0) }
  },
  methods: {
    ...mapActions({ getConfig: 'ucenter/getWechatMoveConfig', create: 'ucenter/createWechatMoveTemplate', rename: 'ucenter/renameWechatMoveTemplate', setDefaultAction: 'ucenter/setDefaultWechatMoveTemplate', remove: 'ucenter/deleteWechatMoveTemplate', clear: 'ucenter/clearWechatMoveTemplateCategoryConfigs', refresh: 'ucenter/refreshWechatMoveCategories', previewGlobal: 'ucenter/getWechatMoveGlobalConfigPreview', importGlobal: 'ucenter/importWechatMoveGlobalConfig', targets: 'ucenter/getWechatMoveTemplateSyncTargets', syncAction: 'ucenter/syncWechatMoveTemplate' }),
    show (shopId) { this.shopId = Number(shopId); if (!this.shopId) return this.$message.error('缺少店铺ID'); this.isGlobalShop = false; this.globalConfiguredAttributeCount = 0; this.visible = true; this.loadConfig(false) },
    loadConfig (keep = true) { const previous = keep ? Number(this.activeTemplateId) : 0; this.loading = true; this.getConfig({ shopId: this.shopId, success: res => { this.loading = false; if (res.code !== 200) return this.$message.error(res.msg || '获取配置失败'); const data = res.data || {}; this.shop = data.shop || {}; this.templates = data.templates || []; this.categoryCount = Number(data.category_count || 0); this.isGlobalShop = Boolean(data.is_global_attribute_shop); this.globalConfiguredAttributeCount = Number(data.configured_attribute_count || 0); this.activeTemplateId = this.templates.some(item => Number(item.id) === previous) ? previous : Number(data.default_template_id || (this.templates[0] || {}).id || 0); if (this.manageVisible) this.openManage() }, fail: () => { this.loading = false; this.$message.error('获取配置失败，请稍后重试') } }) },
    selectTemplate (template) { this.activeTemplateId = Number(template.id); this.templatePopoverVisible = false; this.templateKeyword = '' },
    createTemplateFromPopover () { this.templatePopoverVisible = false; this.templateKeyword = ''; this.createTemplate(false) },
    createTemplate (copy, source) { const origin = source || this.activeTemplate; this.$prompt('请输入模板名称', copy ? '复制模板' : '新建模板', { inputValue: copy ? `${origin.name || '配置'}-副本` : '', inputPattern: /\S+/, inputErrorMessage: '请输入模板名称' }).then(({ value }) => { this.create({ shopId: this.shopId, data: { name: value.trim(), copy_from_template_id: copy ? Number(origin.id) : 0 }, success: res => { if (res.code !== 200) return this.$message.error(res.msg || '创建失败'); this.activeTemplateId = Number(res.data.id); this.$message.success(res.msg || '创建成功'); this.loadConfig() } }) }).catch(() => {}) },
    openManage () { this.templatePopoverVisible = false; this.templateKeyword = ''; this.manageRows = this.templates.map(item => ({ ...item, original_name: item.name })); this.manageVisible = true },
    saveNames () { const changed = this.manageRows.filter(item => item.name !== item.original_name); if (!changed.length) { this.manageVisible = false; return } this.managing = true; const next = index => { if (index >= changed.length) { this.managing = false; this.manageVisible = false; this.loadConfig(); return } const item = changed[index]; this.rename({ templateId: item.id, data: { name: item.name }, success: res => { if (res.code !== 200) { this.managing = false; return this.$message.error(res.msg || '保存失败') } next(index + 1) }, fail: () => { this.managing = false; this.$message.error('保存失败，请稍后重试') } }) }; next(0) },
    setDefault (template) { this.$confirm(`确认将“${template.name}”设为默认模板？`, '提示', { type: 'warning' }).then(() => this.setDefaultAction({ templateId: template.id, success: res => { if (res.code === 200) { this.$message.success(res.msg || '设置成功'); this.loadConfig() } else this.$message.error(res.msg || '设置失败') } })).catch(() => {}) },
    deleteTemplate (template) { this.$confirm(`删除“${template.name}”后，其类目属性配置也会删除。是否继续？`, '提示', { type: 'warning' }).then(() => this.remove({ templateId: template.id, success: res => { if (res.code === 200) { this.$message.success(res.msg || '删除成功'); this.loadConfig(false) } else this.$message.error(res.msg || '删除失败') } })).catch(() => {}) },
    clearConfigs () { this.$confirm(`确认清空模板“${this.activeTemplate.name}”的全部类目属性配置？清空后无法恢复。`, '清空配置', { type: 'warning', confirmButtonText: '确认清空', cancelButtonText: '取消' }).then(() => { this.clearing = true; this.clear({ templateId: this.activeTemplateId, success: res => { this.clearing = false; if (res.code === 200) { this.$message.success(res.msg || '已清空'); this.loadConfig() } else this.$message.error(res.msg || '清空失败') }, fail: () => { this.clearing = false; this.$message.error('清空失败，请稍后重试') } }) }).catch(() => {}) },
    refreshCategories () { this.refreshing = true; this.refresh({ shopId: this.shopId, success: res => { this.refreshing = false; if (res.code === 200) { this.categoryCount = Number((res.data || {}).category_count || 0); this.$message.success(res.msg || '已刷新') } else this.$message.error(res.msg || '刷新失败') }, fail: () => { this.refreshing = false; this.$message.error('刷新失败，请稍后重试') } }) },
    importGlobalAttributes () { this.globalImporting = true; this.previewGlobal({ templateId: this.activeTemplateId, success: res => { this.globalImporting = false; if (res.code !== 200) return this.$message.error(res.msg || '获取系统预设属性预览失败'); const data = res.data || {}; if (!Number(data.importable_count || 0)) return this.$message.warning('当前店铺没有可同步的系统预设属性'); const message = `同步系统预设属性会覆盖当前模板已配置的类目属性。系统已配置 ${data.global_config_count || 0} 个类目，当前店铺可同步 ${data.importable_count || 0} 个，并将清除 ${data.will_clear_count || 0} 个不在同步范围内的类目配置。是否继续？`; this.$confirm(message, '同步系统预设属性', { type: 'warning', confirmButtonText: '确认同步', cancelButtonText: '取消' }).then(() => { this.globalImporting = true; this.importGlobal({ templateId: this.activeTemplateId, data: { confirmed: true }, success: result => { this.globalImporting = false; if (result.code !== 200) return this.$message.error(result.msg || '同步系统预设属性失败'); this.$message.success(result.msg || '系统预设属性已同步到当前模板'); this.loadConfig() }, fail: () => { this.globalImporting = false; this.$message.error('同步系统预设属性失败，请稍后重试') } }) }).catch(() => {}) }, fail: () => { this.globalImporting = false; this.$message.error('获取系统预设属性预览失败，请稍后重试') } }) },
    openSync () { this.syncVisible = true; this.syncLoading = true; this.syncTargets = []; this.targets({ templateId: this.activeTemplateId, success: res => { this.syncLoading = false; if (res.code !== 200) return this.$message.error(res.msg || '获取目标店铺失败'); this.syncTargets = (res.data || []).map(shop => { const templates = shop.templates || []; const defaultTemplate = templates.find(template => template.is_default); return { ...shop, selected: false, target_template_id: Number((defaultTemplate || templates[0] || {}).id || 0) } }) }, fail: () => { this.syncLoading = false; this.$message.error('获取目标店铺失败，请稍后重试') } }) },
    sync () { const selected = this.syncTargets.filter(item => item.selected); if (!selected.length || selected.some(item => !item.target_template_id)) return this.$message.error('请选择目标店铺及模板'); this.$confirm(`确认将“${this.activeTemplate.name}”的整套搬家配置覆盖到选中的 ${selected.length} 个店铺模板？`, '同步搬家配置', { type: 'warning', confirmButtonText: '确认同步', cancelButtonText: '取消' }).then(() => { this.syncSaving = true; this.syncAction({ templateId: this.activeTemplateId, data: { target_template_ids: selected.map(item => item.target_template_id) }, success: res => { this.syncSaving = false; if (res.code === 200) { this.syncVisible = false; this.$message.success(res.msg || '同步成功') } else this.$message.error(res.msg || '同步失败') }, fail: () => { this.syncSaving = false; this.$message.error('同步失败，请稍后重试') } }) }).catch(() => {}) }
  }
}
</script>

<style scoped>
.shop-name {
  color: #999;
  font-size: 12px;
}

.config-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  padding: 20px 0;
}

.config-card {
  padding: 20px 24px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fff;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.card-title {
  margin: 0;
  color: #303133;
  font-size: 16px;
  font-weight: 500;
}

.attribute-stats {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.stat-badge {
  padding: 4px 10px;
  border-radius: 12px;
  background: #f0f7ff;
  color: #409eff;
  font-size: 13px;
  line-height: 18px;
  white-space: nowrap;
}

.attribute-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.attribute-actions .el-button + .el-button {
  margin-left: 0;
}

.setting-button {
  min-width: 124px;
  height: 38px;
  padding: 0 20px;
  font-size: 14px;
}

.sync-category-button {
  border-color: #b3d8ff;
  background: #ecf5ff;
  color: #409eff;
}

.sync-category-button:hover,
.sync-category-button:focus {
  border-color: #409eff;
  background: #409eff;
  color: #fff;
}

.secondary-button {
  color: #303133;
}

.sync-tip {
  display: flex;
  align-items: center;
  margin: 14px 0 0;
  color: #909399;
  font-size: 13px;
  line-height: 20px;
}

.sync-tip i {
  margin-right: 4px;
  color: #409eff;
}

.config-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: auto;
  padding: 14px 0;
  background: #fff;
}

.footer-template-tip {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-right: auto;
  color: #606266;
  font-size: 13px;
  line-height: 20px;
}

.footer-template-tip i {
  color: #409eff;
  font-size: 14px;
}

.footer-template-label {
  color: #606266;
  font-size: 14px;
  white-space: nowrap;
}

.template-select-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 300px;
  height: 40px;
  padding: 0 14px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
  color: #303133;
  font-size: 14px;
  cursor: pointer;
}

.config-footer .template-select-trigger {
  width: 240px;
  height: 36px;
}

.template-select-trigger:hover {
  border-color: #c0c4cc;
}

.template-select-trigger .placeholder {
  color: #c0c4cc;
}

.template-select-trigger i {
  color: #c0c4cc;
  transition: transform 0.2s;
}

.template-select-trigger i.open {
  transform: rotate(180deg);
}

.sync-multi-button {
  min-width: 140px;
  height: 36px;
  font-size: 14px;
}

.template-manage-tip {
  margin-bottom: 16px;
}

.template-name-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.template-name-cell .el-input {
  flex: 1;
}

.default-template-mark {
  flex: 0 0 auto;
  color: #67c23a;
  font-size: 13px;
}

.sync-dialog-tip {
  margin-bottom: 14px;
  color: #909399;
  font-size: 13px;
  line-height: 20px;
}

.sync-template-select {
  width: 100%;
}

.template-popover-content {
  margin: -2px;
}

.template-search {
  margin-bottom: 10px;
}

.template-option-list {
  max-height: 240px;
  overflow-y: auto;
}

.template-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 42px;
  padding: 0 10px;
  border-radius: 3px;
  color: #303133;
  font-size: 14px;
  cursor: pointer;
}

.template-option:hover {
  background: #f5f7fa;
}

.template-option.active {
  color: #409eff;
}

.template-empty {
  padding: 28px 0;
  color: #c0c4cc;
  font-size: 13px;
  text-align: center;
}

.template-popover-actions {
  display: flex;
  align-items: center;
  gap: 22px;
  margin: 8px -10px -10px;
  padding: 10px 12px 0;
  border-top: 1px solid #ebeef5;
}

.template-popover-actions .el-button + .el-button {
  margin-left: 0;
}

@media (max-width: 1200px) {
  .config-body {
    padding: 16px 20px 28px;
  }

  .config-footer {
    padding: 14px 24px;
  }
}

@media (max-width: 900px) {
  .config-body {
    padding: 12px 16px 24px;
  }

  .config-card {
    padding: 16px;
  }

  .card-header {
    margin-bottom: 14px;
  }

  .config-footer {
    padding: 12px 20px;
  }
}
</style>
